import {
  CategoryOrderByInput,
  GetCategoriesQueryVariables,
} from '__generated__/queries-recipe';
import {
  useGlobalBrandKey,
  useGlobalCategorySearchParams,
} from 'utils/globalState';

export const PAGINATION = 100;

export const useCategoriesVariables = (): GetCategoriesQueryVariables => {
  const [brandKey] = useGlobalBrandKey(true);
  const [searchParams] = useGlobalCategorySearchParams();

  return {
    first: PAGINATION,
    where: { brandKey, title_contains: searchParams.search },
    orderBy: CategoryOrderByInput.createdAt_DESC,
    fetchCount: true,
  };
};
